<template>
  <div :id="id" :class="className" :style="{ height: height, width: width }" />
</template>
<script>
import * as echarts from 'echarts';
import resize from "@/components/chart/mixins/resize";
import { parseTime } from "@/utils/index";
import jobTypeColors from "@/utils/iconType";
let chartVm = null;
export default {
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: "chartRrightTop",
    },
    id: {
      type: String,
      default: "chartRrightTop",
    },
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "100%",
    },
    chartData: {
      type: Object,
    },
    unit: {
      type: String,
      default: "台",
    }
  },
  data() {
    return {
      jobTypeColors,
      chart: null,
      options: {
        tooltip: {
          show: false,
          trigger: "axis",
          borderColor: 'rgba(10, 69, 31, 0.8)',
          backgroundColor: 'rgba(10, 69, 31, 0.8)',
          textStyle: {
            color: "#ffffff"
          },
          axisPointer: {
            type: "cross",
            label: {
              color: '#ffffff',
              backgroundColor: "rgba(10, 69, 31, 0.8)",
              formatter(params) {
                console.log('params.value :>> ', params.value);
                if(params.axisDimension == 'y') return params.value.toFixed(2);
                else return parseTime(params.value,'{m}月{d}日',false)
              }
            }
          },
          formatter(params) {
            let dom = '';
            params.map((v,i)=>{
              dom+= `
              <div style="margin: 0px 0 10px;line-height:1;display: flex;align-items: center;">
                  ${v.marker}
                  <span style="font-size:14px;color:#fff;font-weight:400;margin-left:2px">${v.seriesName || '--'}:</span>
                    <span style="float:right;margin-left:20px;font-size:14px;color:#fff;font-weight:900">${v.value || '0'}${chartVm.unit || '台'}</span>
                  </div>
                </div>
              `
            });
            let topDom = params && params.length>0 ? `<div style="font-size:14px;color:#fff;font-weight:400;line-height:1;margin-bottom: 10px">${params[0].axisValueLabel}</div>`:''
            return `<div>${topDom}${dom}</div>`;
          }
        },
        legend: {
          show: false,
          orient: "horizontal",
          x: "right",
          y: "10",
          itemWidth: 20,
          textStyle: {
            color: "#62D9AD",
            fontSize: "12",
          },
          formatter(params) {
            return `${parseTime(dataTime,'{m}月',false)}${params}`
          }
        },
        grid: {
          right: "10px",
          left: "13.5%",
          top: "20.5%",
          bottom: '17%'
        },
        xAxis: {
          type: "category",
          axisLabel: {
            show: true,
            margin: 10,
            fontSize: 12,
            rotate: -0,
            interval: 2,
            showMaxLabel: true,
            textStyle: {
              color: '#ffffff' //X轴文字颜色
            },
            formatter(params) {
              return parseTime(params,'{d}')
            }
          },

          axisLine: {
            show: false,
            lineStyle: {
              color: "#62D9AD",
            },
            width: 1,
          },
          axisTick: {
            //y轴刻度线
            show: false,
          },
          data: [],
        },

        yAxis: {
          minInterval: 1,
          name: `单位(${this.unit || '台'})`,
          type: "value",
          nameTextStyle: {
            color: "#62D9AD",
            fontSize: 12,
            align: 'right'
          },
          axisLabel: {
            interval: 0,
            color: "#ffffff",
            fontSize: 12,
          },
          axisLine: {
            show: false,
            lineStyle: {
              color: "#62D9AD",
            },
            width: 5,
          },
          axisTick: {
            show: false,
          },
          splitLine: {
            lineStyle: {
              color: "rgba(13, 255, 169, 0.1)",
            },
          },
        },
        series: [],
      },
    };
  },
  watch: {
    chartData: {
      deep: true,
      handler(val) {
        this.initChart();
      },
    },
  },
  mounted() {
    chartVm = this;
    this.initChart();
  },
  created() {},
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    setChartData() {
      let series = [];
      if (this.chartData.regionProductionList) {
        let totalLength = this.chartData.regionProductionList.length || 0;
        if(totalLength>1) this.options.tooltip.show = false;
        else this.options.tooltip.show = true;
        let xAxisData = [];
        for (
          let index = 0;
          index < this.chartData.regionProductionList.length;
          index++
        ) {
          const el = this.chartData.regionProductionList[index];
          if(index == this.chartData.regionProductionList.length-1) xAxisData = el.datas.map(v=>{ return v.dates });
          series.push({
            name: `${el.vehicleTypeName || '--'}`,
            type: 'line',
            smooth: 0.2,
            symbolSize: 0,
            itemStyle: {
              color: this.jobTypeColors[String(el.vehicleType)]
              ? this.jobTypeColors[String(el.vehicleType)].echartsLineJobLight
              : this.jobTypeColors["default"].echartsLineJobLight,
              borderColor: this.jobTypeColors[String(el.vehicleType)]
              ? this.jobTypeColors[String(el.vehicleType)].echartsLineJobLight
              : this.jobTypeColors["default"].echartsLineJobLight,
              borderWidth: 1,
              borderType: 'solid'
            },
            data: el.datas.map(v=>{return v.onlineSum})
          });
        }
        this.options.legend.data = this.chartData.legends;
        this.options.xAxis.data = xAxisData;
        this.options.series = series;
        this.chart.setOption(this.options,true); // 设置为true的话，就是notMerge，不合并,false的话，就Merge，之前的东西还保留~
      }
    },
    initChart() {
      if (!this.chart) {
        this.chart = echarts.init(document.getElementById(this.id));
      }
      this.setChartData();
    },
  },
};
</script>
